export default "__VITE_ASSET__BwH$wpWo__"